<template>
  <div>
    <!-- <div v-if="sign == '0'">
      <no-sign @changSign="changSign" />
    </div> -->
    <!--报表系统 v-else  -->
    <div id="reportPage">
      <div class="headerWrap">
        <div class="oneTit">订单管理</div>
        <div v-for="(item,i) of tabList" :key="i" :class="i+2==tabIndex?'active1':''" @click="changOneTab(i)">
          {{ item.name }}
        </div>
      </div>
      <div v-if="tabIndex==1" class="orderWrap">
        <div class="twoTabList">
          <div v-for="(dhTab,index) of dhTabList" :key="index" class="twoItem" :class="dhTabIndex==dhTab.id?'twoActive':''" @click="dhTabIndex=dhTab.id">{{ dhTab.name }}</div>
        </div>
        <div class="twoTabContent">
          <!-- 订货中心订单内容 -->
          <dhOrder :current-index="dhTabIndex" @changeId="changeIndex" />
        </div>
      </div>
      <div v-else-if="tabIndex==2" class="orderWrap">
        <!-- 包含认购类型 -->
        <div class="twoTabList" v-if="APP_SHOW_RENGOUORDER">
          <div v-for="(dhTab,index) of qyTabList" :key="index" class="twoItem" :class="qyTabIndex==dhTab.id?'twoActive':''" @click="qyTabIndex=dhTab.id">{{ dhTab.name }}</div>
        </div>
        <!-- 不包含认购类型 -->
        <div class="twoTabList" v-else>
          <div v-for="(dhTab,index) of qyTabList_1" :key="index" class="twoItem" :class="qyTabIndex==dhTab.id?'twoActive':''" @click="qyTabIndex=dhTab.id">{{ dhTab.name }}</div>
        </div>
        <div class="twoTabContent">
          <!-- 订货商城订单内容 -->
          <qxOrderTab :current-index="qyTabIndex" @changeId="changeIndex" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*global util */

// import noSign from '../myAssetNew/tab/noSign.vue'
import dhOrder from './dhOrderTab/dhOrder.vue'
import qxOrderTab from './qxOrderTab/qxOrderTab.vue'
export default ({
  components: {
    // noSign,
    dhOrder,
    qxOrderTab,

  },
  data() {
    return {
      APP_SHOW_RENGOUORDER: window.g?.APP_SHOW_RENGOUORDER ? window.g.APP_SHOW_RENGOUORDER : false,
      sign: localStorage.getItem('signTea'),
      open: localStorage.getItem('openTea'),
      tabIndex: 2,
      tabList: [{
        name: '订货商城订单',
        id: 2
      }],
      dhTabList: [{
        name: '全部',
        id: 0
      }, {
        name: '待发货',
        id: 1
      }, {
        name: '待收货',
        id: 2
      }, {
        name: '已完成',
        id: 3
      }, {
        name: '退款/售后',
        id: 4
      }],
      qyTabList: [{
        name: '全部',
        id: 0
      }, {
        name: '待发货',
        id: 1
      }, {
        name: '待收货',
        id: 2
      }, {
        name: '已完成',
        id: 3
      }, {
        name: '退款/售后',
        id: 4
      }, {
        name: '认购商品',
        id: 5
      }],
      qyTabList_1: [{
        name: '全部',
        id: 0
      }, {
        name: '待发货',
        id: 1
      }, {
        name: '待收货',
        id: 2
      }, {
        name: '已完成',
        id: 3
      }, {
        name: '退款/售后',
        id: 4
      }],
      qyTabIndex: 0,
      ppTabList: [{
        name: '全部',
        id: 0
      }, {
        name: '待确认',
        id: 1
      }, {
        name: '已确认',
        id: 2
      }, {
        name: '已拒绝',
        id: 3
      }, {
        name: '已取消',
        id: 4
      }],
      ppTabIndex: 0,
      ygTabIndex: 0,
      dhTabIndex: 0,
      twoTabList: [{
        name: '委托明细'
      }, {
        name: '成交明细'
      }
      ],
      treeTabIndex: 2,
      twoTabIndex: 0,
      isChangTab: false, // 是否切换一级标签

      //  {
      //   label: 6,
      //   name: '最近三个月'
      // }
      beginTimeT: [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))],
      beginZtime: [util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000), util.formatnewDay(Number(new Date()) - 24 * 60 * 60 * 1000)],
      currentDate: new Date(),
      millisecond: 1000 * 60 * 60 * 24 // 一天的毫秒数
    }
  },
  computed: {
    commodityOptions() {
      return this.$store.state.hqData.marketDetails
    }
  },
  watch: {
    isChangTab(val) {
      if (val) {
        this.isChangTab = false
        if (this.treeTabIndex == 2) {
          sessionStorage.setItem('marketId_w', 0)
        } else if (this.treeTabIndex == 3) {
          sessionStorage.setItem('marketId_w', 32)
        }
      }
    }
  },
  created() {
    if (this.$route.params && this.$route.params.id) {
      this.tabIndex = this.$route.params.id
    }
  },
  mounted() {

  },
  methods: {
    changSign(value) {
      if (value == 1) {
        this.sign = 1
      } else {
        this.sign = 0
      }
    },
    changOneTab(i) {
      this.tabIndex = i + 2
      // this.tabIndex = i + 1
      this.isChangTab = true
    },
    changeIndex() {
      this.qyTabIndex = 4
    }
  }
})
</script>
<style scoped lang="scss">
.ljsxBtn{
  width: 334px;
  height: 40px;
  cursor: pointer;
  line-height: 40px;
  text-align: center;
  background: #0486FE;
  border-radius: 4px 4px 4px 4px;
  margin-left: calc(50% - 167px);
  margin-top: 35px;
  margin-bottom: 35px;
  font-size: 20px;
font-family: PingFang HK-Medium, PingFang HK;
font-weight: 500;
color: #FFFFFF;
}
#reportPage{
    height:calc(100vh - 50px);
    // background-color:#141625;
  .headerWrap{
      display: flex;
      align-items: center;
      height:58px;
      line-height: 55px;
      background-color:#262941;
      padding-left:240px;
      div{
        margin:0 30px;
        color:#7B94BD;
        font-size: 17px;
        font-family: PingFangSC-Semibold, PingFang SC;
        // font-weight: 600;
        border-bottom:2px solid transparent;
        cursor: pointer;
       }
      .active1{
        color:#CCCFD4;
        // font-weight: 600;
        border-color:#2483FF;
      }
      .oneTit{
        color: rgb(204, 207, 212);
        font-size: 19px;
        padding-right:18px;
      }
  }
  .chooseWrap{
    padding:10px 20px 10px 0;
    display: flex;
    align-items: center;
    background-color: #141625;
    /deep/.el-input__inner{
        background-color:transparent;
        border:1px solid rgba(220, 223, 230, 0.3);
        height: 34px;
        line-height: 34px;
        color: rgba(255, 255, 255, 0.4);
    }
    /deep/.el-range-editor .el-range-input{
         background-color:transparent;
    }
    /deep/.el-date-editor .el-range-separator{
        color:rgba(255, 255, 255, 0.4);
    }
    /deep/.el-date-editor .el-range__icon{
        line-height: 27px;
    }
    /deep/.el-radio{
        margin-right:20px;
    }
    /deep/.el-radio__inner{
        border:1px solid #FFFFFF;
        background-color:transparent;
    }
    /deep/.el-radio__input.is-checked .el-radio__inner{
            background: #141625;
    }
    /deep/.el-radio__inner::after{
        background-color:#2483FF;
        width:10px;
        height:10px;
    }
    .itemSearch{
        margin-left:20px;
        display: flex;
        align-items: center;
        /deep/.el-button span{
            color:#fff;
        }
    }
    .itemSearch .title{
      display: inline-block;
      font-size: 16px;
      font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
      font-weight: 400;
      color: rgba(255,255,255,0.6);
      line-height: 19px;
      margin-right:10px;
      vertical-align: middle;
  }
  /deep/.el-select{
    width: 132px;
   }
  }

  .orderWrap{
    height: 50px;
    background: linear-gradient(180deg, #1F243C 0%, #323855 100%);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    .twoTabList{
        display: flex;
        align-items:center;
    }
    .twoItem{
        cursor: pointer;
        color: #FFFFFF;
        font-weight: 400;
        font-size: 18px;
        padding:0 20px;
        line-height:50px;
        border-right: 1px solid #3D3D3D;
    }
    .twoActive{
        background-color:#2483FF;
    }
  }
  .twoTabContent{
    margin-top:10px;
  }
  .exportButton{
    display: inline-block;
  }
}
</style>
<style lang="scss">
#reportPage{
  .red-row {
    color: #ef5557;
  }
  .green-row {
    color: #00ff05;
  }
  .white-row{
    color:#fff;
  }
  .yellow-row {
    font-weight: 600;
    color: #cee600;
  }
  .spotS {
    color: #0486fe;
  }
  .fw {
    font-weight: 600;
  }
  .fr {
    display: inline-block;
    text-align: right;
    width: 100%;
  }
  .fc {
    color: #fff;
  }
  .el-table__header-wrapper .cell {
    font-weight: 600;
    color: rgba(255, 255, 255, 0.6);
  }

  .el-table__footer-wrapper .cell{
    font-weight: 600!important;
  }
  .el-table__footer-wrapper td:nth-child(n + 7) .cell {
    text-align: right !important;
  }
  }
  #reportPage .el-table{
    margin-bottom:34px;
  }
  #reportPage .el-table__body-wrapper{
    min-height:650px;
  }
#reportPage .paginateWrap{
  position: fixed;
  bottom:0px;
  width:100%;
  background-color: #141625;
}
#reportPage .el-pagination{
  text-align: center;
}
</style>
